import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0ddf39cd&scoped=true"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=0ddf39cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ddf39cd",
  null
  
)

export default component.exports